import { render, staticRenderFns } from "./DiseaseFilter.vue?vue&type=template&id=d3bcaba6&scoped=true&"
import script from "./DiseaseFilter.vue?vue&type=script&lang=ts&"
export * from "./DiseaseFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DiseaseFilter.vue?vue&type=style&index=0&id=d3bcaba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bcaba6",
  null
  
)

export default component.exports